import classNames from "classnames"
import Layer from "./layer"

const Scenes = (props)=>{

    return <Layer className={classNames("land-game-scenes", {mode2: +props.mode === 2},{mode3: +props.mode === 3})}></Layer>
}

export default Scenes